import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import locales from '../../../content.json';
import { RootState } from '../../../store';
import s from './benefits.module.scss';
import img0 from './img/img0.png';
import img1 from './img/img1.png';
import img2 from './img/img2.png';
import img3 from './img/img3.png';
import img4 from './img/img4.png';
import img5 from './img/img5.png';
import img6 from './img/img6.png';
import img7 from './img/img7.png';
import img8 from './img/img8.png';
import img9 from './img/img9.png';
import img10 from './img/img10.png';
import img11 from './img/img11.png';
import img12 from './img/img12.png';
import img13 from './img/img13.png';
import img14 from './img/img14.png';
import img15 from './img/img15.png';
import img16 from './img/img16.png';

import img1Vet from './img/img1Vet.png';
import img2Vet from './img/img2Vet.png';
import img3Vet from './img/img3Vet.png';

import { getParameterFromURL } from '../../../utils/scripts';
import { isTwoPaymentBlocksPaywallEnabled } from '../../../utils/scripts/twoPaymentBlocksPaywall';

export const Benefits = () => {
  const dogTranslator = useSelector((state: RootState) => state.data.dogTranslator) === 'true';
  const vetOnboarding = useSelector((state: RootState) => state.data.vetOnboarding);
  const nutritionOnboarding = useSelector((state: RootState) => state.data.nutritionOnboarding);
  const puppyBlues = useSelector((state: RootState) => state.data.puppyBlues);
  const k9Funnel = useSelector((state: RootState) => state.data.k9Funnel);
  const lastDogTraining = useSelector((state: RootState) => state.data.lastDogTraining);
  const customV20 = getParameterFromURL('config') === 'customV20';
  const puppyOnboarding = getParameterFromURL('puppyOnboarding') === 'true';
  const age = getParameterFromURL('ageValue');
  const twoPaymentBlocksPaywall = isTwoPaymentBlocksPaywallEnabled();

  const v50p20 = getParameterFromURL('config') === 'customV50' && getParameterFromURL('tariff') === 'v41';
  const v49p30 = getParameterFromURL('config') === 'customV49' && getParameterFromURL('tariff') === 'v48';
  const lastDogTrainingPaywall = lastDogTraining || v50p20 || v49p30;
  const customV52 = getParameterFromURL('config') === 'customV52';

  const textValue = useMemo(() => {
    if (k9Funnel) return locales[window.userLang].payment_text_360;
    if (puppyBlues) return locales[window.userLang].payment_text_294;
    if (customV52) return locales[window.userLang].payment_text_266;
    if (twoPaymentBlocksPaywall && !puppyOnboarding) return locales[window.userLang].payment_text_8;
    if (lastDogTrainingPaywall && !puppyOnboarding) return locales[window.userLang].payment_text_229;
    if (!puppyOnboarding) return locales[window.userLang].payment_text_8;

    if (age === '0-6m') {
      return locales[window.userLang].payment_text_221;
    } else {
      return locales[window.userLang].payment_text_222;
    }
  }, [puppyBlues, customV52, puppyOnboarding, age, lastDogTrainingPaywall, twoPaymentBlocksPaywall, k9Funnel]);

  const showVetBenefits = !dogTranslator && vetOnboarding;
  const showNutritionBenefits = !dogTranslator && nutritionOnboarding;

  const data = useMemo(() => {
    if (dogTranslator) {
      return [
        { img: img1, text: locales[window.userLang].payment_text_310 },
        { img: img7, text: locales[window.userLang].payment_text_311 },
        { img: img8, text: locales[window.userLang].payment_text_11 },
        { img: img9, text: locales[window.userLang].payment_text_10 },
        { img: img5, text: locales[window.userLang].payment_text_12 },
        { img: img6, text: locales[window.userLang].payment_text_13 },
      ];
    }

    if (showVetBenefits) {
      return [
        { img: img1Vet, text: locales[window.userLang].payment_text_283 },
        { img: img2Vet, text: locales[window.userLang].payment_text_284 },
        { img: img3Vet, text: locales[window.userLang].payment_text_285 },
        { img: img10, text: locales[window.userLang].payment_text_286 },
        { img: img11, text: locales[window.userLang].payment_text_287 },
        { img: img12, text: locales[window.userLang].payment_text_288 },
      ];
    }

    if (showNutritionBenefits) {
      return [
        { img: img13, text: locales[window.userLang].payment_text_341 },
        { img: img14, text: locales[window.userLang].payment_text_342 },
        { img: img3Vet, text: locales[window.userLang].payment_text_285 },
        { img: img15, text: locales[window.userLang].payment_text_287 },
        { img: img16, text: locales[window.userLang].payment_text_288 },
      ];
    }

    return [
      ...(customV20 ? [{ img: img0, text: locales[window.userLang].payment_text_122 }] : []),
      { img: img1, text: textValue },
      { img: img2, text: locales[window.userLang].payment_text_9 },
      { img: img3, text: locales[window.userLang].payment_text_10 },
      { img: img4, text: locales[window.userLang].payment_text_11 },
      { img: img5, text: locales[window.userLang].payment_text_12 },
      { img: img6, text: locales[window.userLang].payment_text_13 },
    ];
  }, [customV20, dogTranslator, showNutritionBenefits, showVetBenefits, textValue]);

  return (
    <div className={s.benefits}>
      <h2 className={s.title}>
        {showNutritionBenefits
          ? locales[window.userLang].payment_text_350
          : showVetBenefits
          ? locales[window.userLang].payment_text_289
          : locales[window.userLang].payment_text_168}
      </h2>
      <div className={s.itemWrapper}>
        {data.map((item, index) => (
          <div key={index} className={s.item}>
            <img src={item.img} alt="img" />
            <p>{item.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
